import Tasks from 'screens/Tasks';
import Task from 'screens/Tasks/Task';
import TaskView from 'screens/Tasks/Task/TaskView';
import withTasksDecommission from 'screens/Tasks/withTasksDecommission';
import { paths } from 'routes/paths';
import { ROLES } from 'utilities/access';

const GuardedTasks = withTasksDecommission(Tasks);
const GuardedTask = withTasksDecommission(Task);
const GuardedTaskView = withTasksDecommission(TaskView);

const navRoutes = [
  {
    id: 'tasks',
    key: 'tasks',
    path: paths.tasks,
    exact: true,
    secure: true,
    disabled: false,
    component: GuardedTasks
  }
];
const allRoutes = [
  ...navRoutes,
  {
    id: 'taskEntry',
    key: 'taskEntry',
    path: `${paths.tasks}/:id`,
    exact: true,
    secure: true,
    component: GuardedTask,
    minPermissions: {
      minAllowedRole: ROLES.FULL_CONTROL
    }
  },
  {
    id: 'taskView',
    key: 'taskView',
    path: `${paths.tasks}/:id/view`,
    exact: true,
    secure: true,
    component: GuardedTaskView
  },
  {
    id: 'taskConvert',
    key: 'taskConvert',
    path: `${paths.tasks}/:id/convert`,
    exact: true,
    secure: true,
    component: GuardedTask,
    minPermissions: {
      minAllowedRole: ROLES.FULL_CONTROL
    }
  },
  {
    id: 'taskDuplicate',
    key: 'taskDuplicate',
    path: `${paths.tasks}/:id/duplicate`,
    exact: true,
    secure: true,
    component: GuardedTask,
    minPermissions: {
      minAllowedRole: ROLES.FULL_CONTROL
    }
  }
];

export default { navRoutes, allRoutes };
